import axios from 'axios';

const state = {
  stores: [],
  hasFetchedStores: false,
};

const getters = {
  getStores(state) {
    return state.stores;
  },
  hasStores(state) {
    return state.stores.length > 0;
  },
};

export const SET_STORES = 'SET_STORES';
export const SET_HAS_FETCHED_STORES = 'SET_HAS_FETCHED_STORES';

const mutations = {
  [SET_STORES](state, stores) {
    state.stores = stores;
  },
  [SET_HAS_FETCHED_STORES](state, hasFetchedStores) {
    state.hasFetchedStores = hasFetchedStores;
  },
};

// Shared in-flight request so concurrent callers (headers, footer, route guard) trigger a single call
let fetchStoresRequest = null;

const actions = {
  /**
   * Fetch the stores configured to be shown in WebCart, once per session.
   * A failed request is not cached, so a later call retries it.
   */
  fetchStores({ state, commit }) {
    if (state.hasFetchedStores) {
      return Promise.resolve();
    }
    if (!fetchStoresRequest) {
      fetchStoresRequest = axios
        .get('api/stores')
        .then(storesResponse => {
          commit(SET_STORES, storesResponse?.data?.data ?? []);
          commit(SET_HAS_FETCHED_STORES, true);
        })
        .catch(error => {
          console.error('Failed to fetch stores:', error);
        })
        .finally(() => {
          fetchStoresRequest = null;
        });
    }
    return fetchStoresRequest;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
